import { FC } from 'react';
import { Layout } from 'antd';
import 'antd/dist/reset.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Role } from '../../models/enums/Role';
import AiTrainer from '../AiTrainer/AiTrainer';
import { AppSideMenu } from '../SideMenu/AppSideMenu';
import CreateCampaign from '../CreateCampaign/CreateCampaign';
import DaysCalendar from '../DaysCalendar/DaysCalendar';
import EventsScreen from '../../screens/EventsScreen';
import LogOut from '../LogOut/LogOut';
import Login from '../Login/Login';
import Register from '../Register/Register';
import RequireAuth from '../RequiereAuth/RequireAuth';
import TasksScreen from '../../screens/TasksScreen';
import SipAccounts from '../SIPAccounts/SIPAccounts';
import SIPAccountDetail from '../SIPAccounts/SIPAccountDetail';
import { CallsScreen } from '../../screens/CallsScreen';
import { IncomingCallsScreen } from '../../screens/IncomingCallsScreen';
import { StatisticsV2Screen } from '../../screens/StatisticsV2Screen';
import { IncomingStatisticsV2Screen } from '../../screens/IncomingStatisticsV2Screen';
import { DispensarizationStatisticsScreen } from '../../screens/DispensarizationStatistics';
import { BlacklistScreen } from '../../screens/BlacklistScreen';
import { QuestionnaireTemplatesScreen } from '../../screens/QuestionnaireTemplatesScreen';
import { SettingsCallsScreen } from '../../screens/SettingsCallsScreen';
import { ClinicSettingsDetailScreen } from '../../screens/ClinicSettingsDetailScreen';
import { CallPoolSettingsScreen } from '../../screens/CallPoolSettingsScreen';
import '../../uikit/styles/variables.module.css';
import styles from './style.module.css';
import { UsersScreen } from '../../screens/UsersScreen';
import { NotFoundScreen } from '../../screens/NotFoundScreen';
import { HomeScreen } from '../../screens/HomeScreen';

const { Content } = Layout;

const App: FC = () => {
  return (
    <Layout className={styles.layout} hasSider>
      <AppSideMenu />
      <Content className={styles.content}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/logout" element={<LogOut />} />
          <Route path="/404" element={<NotFoundScreen />} />
          <Route
            path="/blacklist"
            element={
              <BlacklistScreen
                allowedRoles={[Role.ClinicAdmin, Role.Admin, Role.SuperAdmin]}
              />
            }
          />
          <Route
            path="/settings/users"
            element={
              <UsersScreen allowedRoles={[Role.Admin, Role.SuperAdmin]} />
            }
          />

          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  Role.User,
                  Role.ClinicAdmin,
                  Role.Admin,
                  Role.SuperAdmin,
                ]}
              />
            }
          >
            <Route path="/" element={<HomeScreen />} />
            <Route
              path="/statistics/outgoing"
              element={<StatisticsV2Screen />}
            />
            <Route
              path="/statistics/incoming"
              element={<IncomingStatisticsV2Screen />}
            />
            <Route path="/tasks" element={<TasksScreen />} />
            <Route path="/calls/incoming" element={<IncomingCallsScreen />} />
            <Route path="/calls/outgoing" element={<CallsScreen />} />
            <Route path="/create-campaign" element={<CreateCampaign />} />
            <Route path="/calendar" element={<DaysCalendar />} />
            <Route path="/aitrainer" element={<AiTrainer />} />

            <Route path="/events" element={<EventsScreen />} />
          </Route>

          <Route
            element={
              <RequireAuth
                allowedRoles={[Role.Admin, Role.SuperAdmin]}
                forbiddenRedirectTo404={true}
              />
            }
          >
            <Route
              path="/questionnaire-templates"
              element={<QuestionnaireTemplatesScreen />}
            />
          </Route>

          <Route
            element={
              <RequireAuth allowedRoles={[Role.Admin, Role.SuperAdmin]} />
            }
          >
            <Route path="/settings/calls" element={<SettingsCallsScreen />} />
            <Route
              path="/settings/calls/:clinicId"
              element={<ClinicSettingsDetailScreen />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                allowedRoles={[Role.SuperAdmin]}
                forbiddenRedirectTo404={true}
              />
            }
          >
            <Route path="/sip-accounts" element={<SipAccounts />} />
            <Route path="/sip-accounts/new" element={<SIPAccountDetail />} />
            <Route path="/sip-accounts/:id" element={<SIPAccountDetail />} />
            <Route
              path="/settings/callpools"
              element={<CallPoolSettingsScreen />}
            />
          </Route>

          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default App;
